module.exports = __webpack_public_path__ + "img/6.34ce7e6.jpg";